import { TypographyWithEllipsis } from '@modules/common/components/TypographyWithEllipsis';
import { TRACKED_KEYWORD_SENTIMENT } from '@modules/common/constants';
import { Stack, Typography } from '@mui/material';
import { OperationType } from 'v2/core/services/queryBuilder/whereClause';

interface EntitySentimentFilterPreviewProps {
  values: string[];
  conjunction?: OperationType;
}

export const EntitySentimentFilterPreview = ({
  values,
  conjunction,
}: EntitySentimentFilterPreviewProps) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" color="text.secondary">
        {conjunction}
      </Typography>
      <Stack sx={{ pb: 1 }}>
        <Typography variant="caption" color="text.secondary">
          {TRACKED_KEYWORD_SENTIMENT}
        </Typography>
        <TypographyWithEllipsis variant="body2" color="primary">
          {values.join(', ')}
        </TypographyWithEllipsis>
      </Stack>
    </Stack>
  );
};
